// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V3$Linear from "./V3.res.js";

function fill(v) {
  return V3$Linear.fill(V3$Linear.fill(v));
}

function map(mat, f) {
  return V3$Linear.map(mat, __x => V3$Linear.map(__x, f));
}

function transpose(param) {
  let match = param[2];
  let match$1 = param[1];
  let match$2 = param[0];
  return [
    [
      match$2[0],
      match$1[0],
      match[0]
    ],
    [
      match$2[1],
      match$1[1],
      match[1]
    ],
    [
      match$2[2],
      match$1[2],
      match[2]
    ]
  ];
}

function jsonCodec(elementCodec) {
  return V3$Linear.jsonCodec(V3$Linear.jsonCodec(elementCodec));
}

export {
  fill,
  map,
  transpose,
  jsonCodec,
}
/* No side effect */
